<template>

    <div class="row"  >

<!-- <button @click="applyCustomClass" class="custom-mobileStile" type="button"></button>-->
      <button v-if="showResetButton" @click="resetCustomClass"   class="reset-style-btn btn bg-transparent delete-button" type="button">
        <svg data-v-3958b468="" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path data-v-3958b468="" fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z" fill="#7c7c7c"></path></svg>

      </button>
      <div class="mb-3 col-xs-1 select-customer-container-icon">
          <div v-if="this.counter > 1"  class="img-circle text-center thumbnail m-bottom-0">{{ counter }}</div>
            <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none"
                 xmlns="http://www.w3.org/2000/svg" style="height: 28.5px">
                <path
                    d="M8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2ZM8 12C10.7 12 13.8 13.29 14 14H2C2.23 13.28 5.31 12 8 12ZM8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z"
                    fill="#2E4051"/>
            </svg>
        </div>
        <div class="mb-3 col-xs-11 select-customer-container dropdown p-right-0 " :class="{'w-90': counter !== 1 && !(selectedCustomer && selectedCustomer.customer_id)}" >
            <!--        <div class="mb-3 col-md-12 select-customer-container dropdown">-->


            <!--          <svg width="22" height="16" class="float-left" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 5V2H17V5H14V7H17V10H19V7H22V5H19ZM8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2ZM14.39 10.56C12.71 9.7 10.53 9 8 9C5.47 9 3.29 9.7 1.61 10.56C0.61 11.07 0 12.1 0 13.22V16H16V13.22C16 12.1 15.39 11.07 14.39 10.56ZM14 14H2V13.22C2 12.84 2.2 12.5 2.52 12.34C3.71 11.73 5.63 11 8 11C10.37 11 12.29 11.73 13.48 12.34C13.8 12.5 14 12.84 14 13.22V14Z" fill="#2E4051"/>
                      </svg>-->
            <select ref="input" placeholder="Find a customer" :id="fieldId" :name="fieldName"
                    class="form-control float-right form-control-lg customer-tom-selector">
            </select>
        </div>
        <!-- Modal -->
        <div rel="modal" class="modal modal-fullscreen" :id="`customers-modal-mobile-view_${counter}`" tabindex="-1"
             role="dialog" :aria-labelledby="`customers-modal-mobile-view_${counter}`">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="display-inline-block"></h3>
                        <button type="button" class="close-btn close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body no-scroll">
                        <div class="row">
                            <div class="mb-3 select-customer-popup-container dropdown " style="z-index: 9999">

                                <select ref="popup_input" placeholder="Search by name or phone number"
                                        id="customer_popup"
                                        name="customer_popup"
                                        class="form-control form-control-lg customer-tom-selector">
                                </select>

                            </div>

                            <div :class="{'create_new_customer_js':true, 'hidden':!can_add }">
                                <a class="create_new_customer_js_link p-left-13"
                                   id="add_customer" href="#"
                                   data-toggle="modal"
                                   data-target="#create_edit_customer_popup"
                                   onclick="$(`#customers-modal-mobile-view_${counter}`).modal('hide')"
                                   style="color: #2E4051; text-decoration: none;padding: 7px 9px 3px -2px;">
                                    <svg width="20" height="20" style="fill: #03A9F4;" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="#03A9F4"/>
                                    </svg>
                                    <span style="position: relative; left: 5px;">New Customer</span>
                                </a>
                            </div>

                            <div ref="dropdownContentMobile"
                                 style="width: 100%; position:relative; padding: 0;"></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                    </div>
                </div>
            </div>
            <!-- End Modal -->
        </div>
    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import TomSelect from 'tom-select'
import {getCustomers} from "../api";

export default {
    name: "selectCustomersDropdown",
    props: {
        counter: null,
        can_add: true,
        can_edit: true,
        display_icon: true,
        value: null,
        bookingCustomers: null,
        fieldName: {
            type: String,
            default() {
                return 'customer_id';
            },
        },
        fieldId: {
            type: String,
            default() {
                return 'customer_id';
            },
        },
      //  removeCustomerInput: Function,

    },
    data() {
        return {
            customersid: 0,
            select: null,
            popupSelect: null,
            customers: [],
            bookingCustomersArray: this.bookingCustomers,
            categories: [],
            windowWidth: this.getScreenWidth(),
            openOnFocus: true,
            thereIsMore: true,
            thereIsMorePopup: true,
            selectedCustomer: this.value,
            isCustomClassApplied: false,
            showResetButton: false
        }
    },
    computed: {
        isMobile() {
            return this.windowWidth < 460
        }
    },
    methods: {
        removeDuplicateObjectsInArray(arr, properties = []) {
            return arr.filter((v, i, a) => a.findIndex(v2 => properties.every(k => v2[k] === v[k])) === i)
        },
        getScreenWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
        listenToBrowserSize() {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth
            })
        },
        initializeTomSelect() {
            let vm = this;
            this.$nextTick(() => {
                // I added the variable to window to use it in jquery in other pages
                this.select = window.customersSelect = new TomSelect(this.$refs['input'], {
                    preload: false,
                    maxOptions: null,
                    searchField: ['state', 'first_name', 'last_name', 'phone', 'email1', 'business_name', 'mobile2', 'full_address',
                        'street_number', 'street_address', 'suburb', 'postcode', 'unit_lot_number'],
                    valueField:'customer_id',
                    dropdownParent: this.parent,
                    closeAfterSelect: true,
                    duplicates: true,
                    highlight: false,
                    persist: false,


                    load: function (query, callback) {
                        if (query) {
                            let page = this.getUrl(query) ?? 1
                            getCustomers({name: query, page: page})
                                .then(response => {
                                    if (response.data.length > 0) {
                                        vm.thereIsMore = true
                                        this.setNextUrl(query, ++page)
                                    } else {
                                        vm.thereIsMore = false
                                    }
                                    vm.customers = [...vm.customers, ...response.data]
                                    vm.removeDuplicateObjectsInArray(vm.customers, [vm.fieldName])
                                    callback(response.data);
                                })
                                .catch(error => {
                                    callback([])
                                })
                        }
                    },
                    firstUrl: function (query) {
                        return 1
                    },
                    openOnFocus: this.openOnFocus,
                    plugins: {
                        'dropdown_header': {
                            html() {
                                return `<div class="create_new_customer_js ${(!vm.can_add?'hidden':'')}" style="border-bottom: 1px solid #8080804a">
                                            <a class="create_new_customer_js_link" id="add_customer" href="#" data-toggle="modal" data-target="#create_edit_customer_popup" style="color: #2E4051; text-decoration: none;padding: 7px 9px 3px -2px;">
                                                <svg width="20" height="20" style="fill: #03A9F4;" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="#03A9F4"/>
                                                </svg>
                                                <span style="position: relative; top: -5px;left: 5px;">New Customer</span>
                                            </a>
                                        </div>`
                            },

                        },
                        'virtual_scroll': {}
                    },
                    render: {
                        option: function (item, escape) {
                            let phoneHtml = '';
                            let emailHtml = '';
                            let displaynameHTML = '';
                            let image = '';
                            let eventBus = EventBus;


                            if (item.phone) {
                                phoneHtml = ` <b>-</b> ${escape(item.phone)}`;
                            }
                            if (item.email1) {
                                emailHtml = ` <b>-</b> ${escape(item.email1)}`;
                            }

                            if (item.business_name) {
                                displaynameHTML = `${unescape(item.business_name)}`
                                image = '<div class="float-left"><svg width="24" height="18" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.36 5L15.96 8H2.04L2.64 5H15.36ZM17 0H1V2H17V0ZM17 3H1L0 8V10H1V16H11V10H15V16H17V10H18V8L17 3ZM3 14V10H9V14H3Z" fill="#03A9F4"/> </svg></div>'

                            } else {
                                if (typeof (item.last_name) == "undefined") {
                                    item.last_name = '';
                                }
                                displaynameHTML = `${escape(item.first_name)}` + ' ' + `${escape(item.last_name)}`
                                image = '<img src="data:image/png;base64,' + `${item.image}` + '" class="img-circle" alt="" width="24">'
                            }

                            return `<div class="col-12  customerList_mobile optionListValueCustomer">
                                      ${image}
                                      <span class="float-start">${displaynameHTML}</span>
                                      <span class="float-start text-muted">${phoneHtml}${emailHtml}</span>
                                      <a class="editCustomer_searchCustomerInput ${(!vm.can_edit?'hidden':'')} col-1" href="javascript:void(0)" id="editCustomer${vm.counter}">
                                       <svg data-v-7796ae10="" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-7796ae10="" d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#979FA8"></path></svg>
                                       </a>
                                  </div>`
                        },
                        item: function (data, escape) {
                            let phoneHtml = '';
                            let emailHtml = '';
                            let displaynameHTML = '';
                            let image = '';
                            let threeDotsIcon = '';
                            if (data.phone) {
                                phoneHtml = `${escape(data.phone)}`;
                            }
                            if (data.email1) {
                                if (data.phone)
                                    emailHtml = ` <b>-</b> `
                                emailHtml += `${escape(data.email1)}`;
                            }
                            if (data.business_name) {
                                displaynameHTML = `${unescape(data.business_name)}`
                                image = '<div class="float-left"><svg width="24" height="18" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.36 5L15.96 8H2.04L2.64 5H15.36ZM17 0H1V2H17V0ZM17 3H1L0 8V10H1V16H11V10H15V16H17V10H18V8L17 3ZM3 14V10H9V14H3Z" fill="#03A9F4"/> </svg></div>'
                            } else {
                                displaynameHTML = `${escape(data.first_name)}` + ' ' + `${escape(data.last_name)}`
                                image = '<img src="data:image/png;base64,' + `${data.image}` + '" class="img-circle" alt="" width="24">'
                            }
                            if(vm.can_edit){
                              threeDotsIcon = `<a href="javascript:;" class="dropdown-toggle  " role="button" id="BookingCustomerDropdown${vm.counter}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <div class="three_dots_style btn">
                                                <i  class="fa  fa-ellipsis-v " style="color:#03A9F4;font-size: 18px;" >
                                                </i>
                                                </div>
                                            </a>`
                            }
                            return `<div class="col-12">
                                       ${image}
                                        <div class="float-start" style="margin-left: 10px">
                                            <span class="d-block" id="bookingSelectedCustomerName">${displaynameHTML}</span>
                                            <span class="d-block text-muted" id="bookingSelectedCustomerPhone" style="display: block">${phoneHtml}<span class="email-desktop-only">${emailHtml}</span></span>
                                        </div>
                                        <div class="dropdown customer-dropdown" onmouseenter="$('#BookingCustomerDropdown${vm.counter}').dropdown();" onclick="event.stopPropagation();$('#BookingCustomerDropdown${vm.counter}').dropdown();" style="position: absolute;right: 2px;width: 30px;text-align: center; cursor: pointer">
                                            ${threeDotsIcon}
                                            <ul class=" dropdown_menu_custom_data dropdown-menu dropdown-menu-right" aria-labelledby="BookingCustomerDropdown${vm.counter}">
                                                <li> <a href="javascript:void(0)" id="editCustomer${vm.counter}">
                                                <span class="m-right-10 desktop-position">
                                               <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#03A9F4"/>
                                              </svg>
                                                </span><span class="edit-customer-details">Edit customer details</span></a></li>
                                                <li><a href="javascript:void(0)" onclick="VueEventBus.$emit('removeCustomer',${data.customer_id});">
                                                <span class="m-right-10 remove-desktop-position">
                                                <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" fill="#03A9F4"/>
                                                </svg>
                                                </span>
                                                <span class="edit-customer-details p-left-5"> Remove customer</span>
                                                </a></li>
                                             </ul>
                                        </div>
                                    </div>`
                        },
                    },

                }),

                this.select.on('focus', () => {
                    let dropdownInputCustom = document.getElementById('dropdown-input-custom');
                    if (!dropdownInputCustom && !(vm.customers.length > 0)) {
                        $(this.select.dropdown_content).parent().append(`<span id="dropdown-input-custom" style="border:none; font-weight: 600;" type="select-one" autocomplete="off" size="1" tabindex="-1" class="dropdown-input col-md-12">Search by name, email, or phone number</span>`)
                    }
                    if (!(vm.customers.length > 0)) {
                        $(this.select.dropdown_content).parent().show()
                    }

                })

                this.select.on('type', (str) => {
                    let dropdownInputCustom = document.getElementById('dropdown-input-custom');
                    if (dropdownInputCustom) {
                        dropdownInputCustom.remove();

                    }
                })
            })

        },
        initializePopupTomSelect(customers) {
            let vm = this;
            this.$nextTick(() => {
                // I added the variable to window to use it in jquery in other pages
                this.popupSelect = window.mobileCustomersSelect = new TomSelect(this.$refs['popup_input'], {
                    preload: false,
                    maxOptions: null,
                    searchField: ['state', 'first_name', 'last_name', 'phone', 'email1', 'business_name', 'mobile2', 'full_address',
                        'street_number', 'street_address', 'suburb', 'postcode', 'unit_lot_number'],
                    valueField: 'customer_id',
                    dropdownParent: this.$refs.dropdownContentMobile,
                    closeAfterSelect: true,
                    duplicates: true,
                    highlight: false,
                    persist: false,
                    shouldLoadMore(data, escape) {
                        return vm.thereIsMorePopup;
                    },
                    firstUrl: function (query) {
                        return 1
                    },
                    load: function (query, callback) {
                        let page = this.getUrl(query) ?? 1
                        if (query) {
                            getCustomers({name: query, page: page, perpage: 20})
                                .then(response => {
                                    if (response.data.length) {
                                        vm.thereIsMorePopup = true
                                        this.setNextUrl(query, ++page)
                                    } else {
                                        vm.thereIsMorePopup = false
                                    }
                                    vm.customers = [...vm.customers, ...response.data]
                                    vm.removeDuplicateObjectsInArray(vm.customers, ['customer_id'])
                                    callback(response.data);
                                })
                                .catch(error => {
                                    callback([])
                                })
                        }
                    },
                    openOnFocus: this.openOnFocus,
                    plugins: {
                        'virtual_scroll': {}
                    },
                    render: {
                        option: function (item, escape) {
                            let phoneHtml = '';
                            let emailHtml = '';
                            let displaynameHTML = '';
                            let image = '';
                            if (item.phone) {
                                phoneHtml = `${escape(item.phone)}`;
                                // phoneHtml = ` <b>-</b> ${escape(item.phone)}`;
                            }
                            if (item.email1) {
                                emailHtml = ` <b>-</b> ${escape(item.email1)}`;
                            }
                            if (item.business_name) {
                                displaynameHTML = `<b>${unescape(item.business_name)}</b>`
                                image = '<div class="float-left"><svg width="24" height="18" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.36 5L15.96 8H2.04L2.64 5H15.36ZM17 0H1V2H17V0ZM17 3H1L0 8V10H1V16H11V10H15V16H17V10H18V8L17 3ZM3 14V10H9V14H3Z" fill="#03A9F4"/> </svg></div>'
                            } else {
                                if (typeof (item.last_name) == "undefined") {
                                    item.last_name = '';
                                }
                                displaynameHTML = `<b>${escape(item.first_name)}</b>` + ' ' + `${escape(item.last_name)}`
                                image = '<img src="data:image/png;base64,' + `${item.image}` + '" class="img-circle" alt="" width="24">'
                            }

                return `<div class="col-12 customerList_mobile optionListValueCustomer">
                                     ${image}
                                      <span class="float-start">${displaynameHTML}</span>
                                      <span class="float-start text-muted">${phoneHtml}</span>
                                      <a class="editCustomer_searchCustomerInput" href="javascript:void(0)" id="editCustomer${vm.counter}">
                                       <svg data-v-7796ae10="" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-7796ae10="" d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#979FA8"></path></svg>
                                       </a>
                                  </div>`
                        },
                        item: function (data, escape) {
                            let phoneHtml = '';
                            let emailHtml = '';
                            let displaynameHTML = '';
                            let image = '';
                            if (data.phone) {
                                phoneHtml = `${escape(data.phone)}`;
                            }
                            if (data.email1) {
                                if (data.phone)
                                    emailHtml = ` <b>-</b> `
                                emailHtml += `${escape(data.email1)}`;
                            }
                            if (data.business_name) {
                                displaynameHTML = `${unescape(data.business_name)}`
                                image = '<div class="float-left"><svg width="24" height="18" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.36 5L15.96 8H2.04L2.64 5H15.36ZM17 0H1V2H17V0ZM17 3H1L0 8V10H1V16H11V10H15V16H17V10H18V8L17 3ZM3 14V10H9V14H3Z" fill="#03A9F4"/> </svg></div>'
                            } else {
                                displaynameHTML = `${escape(data.first_name)}` + ' ' + `${escape(data.last_name)}`
                                image = '<img src="data:image/png;base64,' + `${data.image}` + '" class="img-circle" alt="" width="24">'
                            }
                            return `<div class="col-12">
                                       ${image}
                                        <div class="float-start" style="margin-left: 10px">
                                            <span class="d-block" id="bookingSelectedCustomerName">${displaynameHTML}</span>
                                            <span class="d-block text-muted" id="bookingSelectedCustomerPhone" style="display: block">${phoneHtml}${emailHtml}</span>
                                        </div>
                                        <div class="dropdown customer-dropdown"
                                        onmouseenter="event.stopPropagation();$('#BookingCustomerDropdown2${vm.counter}').dropdown('show');"
                                        onclick="event.stopPropagation();$('#BookingCustomerDropdown2${vm.counter}').dropdown('show');"
                                        style="position: absolute;right: 31px;top: 10px;width: 30px;text-align: center; cursor: pointer;z-index:999">
                                            <a href="#" class="dropdown-toggle" role="button" id="BookingCustomerDropdown2${vm.counter}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <div class="three_dots_style btn">
                                                <i  class="fa  fa-ellipsis-v " style="color:#2E4051;font-size: 18px;" >
                                                </i>
                                                </div>
                                            </a>
                                             <ul class="  dropdown_menu_custom_data dropdown-menu dropdown-menu-right" aria-labelledby="BookingCustomerDropdown2${vm.counter}">
                                              <li> <a href="javascript:;" id="editCustomer${vm.counter}">
                                              <span class="m-right-10">
                                               <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#03A9F4"/>
                                              </svg>
                                               </span><span class="edit-customer-details">Edit customer details</span></a></li>
                                              <li><a href="#" onclick="VueEventBus.$emit('removeCustomer',${data.customer_id});"><span class="m-right-10">
                                              <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" fill="#03A9F4"/>
                                              </svg>
                                              </span>
                                              <span class="edit-customer-details p-left-5"> Remove customer</span>
                                              </a></li>
                                             </ul>
                                        </div>
                                    </div>`
              }
            },
          })
        })
      },
        listenToTomSelectEvents() {
            let vm = this
            this.$nextTick(() => {

                let icon = $(`<a id="clear-input" class="p-right-10" href="javascript:;" onclick="$('#${vm.fieldName}-ts-control,#customer_popup-ts-control').val('')"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z" fill="#2E4051"/>
                            </svg>
                            </a>`)

                // This for input field icon
                let selectedCount = 0;

                // close menu
                this.select.on('dropdown_open', () => {
                    if (!this.isMobile || !vm.display_icon) {
                        $(`#BookingCustomerDropdown${vm.counter}`).dropdown('toggle');
                    } else {
                        $(`#customers-modal-mobile-view_${vm.counter}`).modal('toggle')
                    }
                });

                // Add customer
                this.select.on('item_add', (value, item) => {

                    if (document.getElementById("customer_id-ts-control")) {
                        document.getElementById("customer_id-ts-control").setAttribute('readonly', true);
                    }
                    if (document.getElementById("auto_customer_id-ts-control")) {
                        document.getElementById("auto_customer_id-ts-control").setAttribute('readonly', true);
                    }

                    $('#clear-input').hide()
                    let customer = this.customers.find(customer => customer.customer_id == value)
                    if (!customer) {
                        getCustomers({id: value})
                            .then(response => {
                                this.customers = [...this.customers, ...response.data]
                                this.removeDuplicateObjectsInArray(this.customers, ['customer_id'])
                                customer = this.customers.find(customer => customer.customer_id == value)
                                if(this.counter===1){
                                EventBus.$emit('onCustomerChanged', customer,customer.default_bill_payer)}
                              this.selectedCustomer = {...this.selectedCustomer,...{'customer_id':customer.customer_id,'customer_name':customer.first_name+" "+customer.last_name,
                                'default_bill_payer':customer.default_bill_payer}}

                            })
                    } else {
                        if(this.counter===1) {
                            EventBus.$emit('onCustomerChanged', customer, customer.default_bill_payer)
                        }
                      this.selectedCustomer = {...this.selectedCustomer,...{'customer_id':customer.customer_id,'customer_name':customer.first_name+" "+customer.last_name,
                        'default_bill_payer':customer.default_bill_payer}}

                    }

                    $(`#editCustomer${vm.counter}`).on('click', function () {
                      EventBus.$emit('setCustomerId', customer.customer_id);
                      VueEventBus.$emit('openModalCustomer', true);
                      $(`#create_edit_customer_popup`).modal("show");
                    })
                })
                //  remove customer
                this.select.on('item_remove', (value, item) => {

                    if(this.counter===1){
                    EventBus.$emit('onCustomerChanged', null)
                    this.selectedCustomer = null;
                    }
                    if (document.getElementById("customer_id-ts-control")) {
                        document.getElementById("customer_id-ts-control").removeAttribute('readonly');
                    }
                    if (document.getElementById("auto_customer_id-ts-control")) {
                        document.getElementById("auto_customer_id-ts-control").removeAttribute('readonly');
                    }
                    if($("#auto_customer_id").length > 0)
                      $("#auto_customer_id").val("");

                    /** removing dropdown on focus class **/
                    var dates_querySelectorAll = document.querySelectorAll('[class^="vue_focus_dropdown_"]');
                    for (var i = 0; i < dates_querySelectorAll.length; i++) {
                        dates_querySelectorAll[i].style.display = "none";

                    }

                    var Saved_locations_vue_focus = $('#Saved_locations_vue_focus');
                    for (var i = 0; i < Saved_locations_vue_focus.length; i++) {
                        Saved_locations_vue_focus[i].style.display = "none";
                        Saved_locations_vue_focus[i].remove();
                    }
                    var Saved_locations_vue = $('#Saved_locations_vue');
                    for (var i = 0; i < Saved_locations_vue.length; i++) {
                        Saved_locations_vue[i].style.display = "none";
                        Saved_locations_vue[i].remove();
                    }

                    var Enter_address_manually = document.querySelectorAll('[id^="Enter_address_manua"]');
                    for (var i = 0; i < Enter_address_manually.length; i++) {
                        Enter_address_manually[i].style.display = "none";
                        Enter_address_manually[i].remove();
                    }
                    var customer_address = document.querySelectorAll('[id^="customer_addre"]');
                    for (var i = 0; i < customer_address.length; i++) {
                        customer_address[i].style.display = "none";
                        customer_address[i].remove();
                    }

                    if(this.bookingCustomers && this.bookingCustomers.length <=1 ){
                        /** do not remove the main booking location if the admin removes one of customers **/
                        window.removing_postCalling();
                    }
                })

                this.select.on('focus', () => {

                    // let selectedValue = this.select.getValue()
                    //
                    // console.log(selectedValue)

                    // if (!($('#clear-input').length > 0) &&  $('#clear-input').parent().children().length <= 2) {
                    //   $(`.customer-tom-selector`).find(`.ts-control`).append(icon);
                    // }else if( $('#clear-input').parent().children().length <= 2){
                    //   $('#clear-input').show()
                    // }

                    $(".customerList_mobile.option.optionListValueCustomer").each(function (){
                        let customerId = $(this).attr("data-value");
                        $(this).find(`#editCustomer${vm.counter}`).on('click', function () {
                            $(`#create_edit_customer_popup`).modal("show");
                            EventBus.$emit('setCustomerId', customerId)
                            VueEventBus.$emit('openModalCustomer', true);
                        })
                    });
                    if (this.isMobile && vm.display_icon) { //Exclude customer dropdown at filters at listing pages
                        this.select.lock()
                        $(`#customers-modal-mobile-view_${vm.counter}`).modal('show')
                        this.popupSelect.focus()
                    }

                });
                this.select.on('type', () => {
                    if (!($('#clear-input').length > 0) && $('#clear-input').parent().children().length <= 2) {
                        $(`.customer-tom-selector`).find(`.ts-control`).append(icon);
                    } else if ($('#clear-input').parent().children().length <= 2) {
                        $('#clear-input').show()
                    }
                });
                this.select.on('blur', () => {
                    if ($('#clear-input').length > 0) {
                        $('#clear-input').hide()
                    }
                })

                /** This to fix automatic scroll to top bug on dropdown autoloading tom-select  */
                this.select.on('load', (data) => {
                    if (document.getElementById(`${vm.fieldName}-ts-control`).value) {
                        let options = document.querySelectorAll('.customer-tom-selector .customerList_mobile.option')
                        $('.customer-tom-selector .customerList_mobile.option').removeClass('active')
                        $('.customer-tom-selector .customerList_mobile.option').removeAttr('aria-selected')

                        $(".customerList_mobile.option.optionListValueCustomer").each(function (){
                            let customerId = $(this).attr("data-value");
                            $(this).find(`#editCustomer${vm.counter}`).on('click', function () {
                                $(`#create_edit_customer_popup`).modal("show");
                                EventBus.$emit('setCustomerId', customerId);
                                VueEventBus.$emit('openModalCustomer', true);
                            })
                        })

                        this.select.clearActiveOption()
                        this.$nextTick(() => {
                            this.select.setActiveOption(options[options.length - 9])
                        })
                    }
                })

            })
        },
        listenToPopupTomSelectEvents() {
            let vm = this
            this.$nextTick(() => {
                let icon = $(`<a id="clear-input" class="p-right-10" href="javascript:;" onclick="$('#${vm.fieldName}-ts-control,#customer_popup-ts-control').val('')"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z" fill="#2E4051"/>
                            </svg>
                            </a>`)
                // This for input field icon
                let selectedCount = 0;

                // Add customer
                if (  this.popupSelect){
                    this.popupSelect.on('item_add', (value, item) => {
                        $(`#customers-modal-mobile-view_${vm.counter} #clear-input`).hide()
                        let customer = this.customers.find(customer => customer.customer_id == value)
                        if (customer) {
                            this.select.addOption(customer)
                            this.select.addItem(value)
                            // window.select_customer(value, `${customer.first_name} ${customer.last_name}`, 0, 0, '0');
                        }
                        $(`#customers-modal-mobile-view_${vm.counter}`).modal('toggle')
                        $(`#editCustomer${vm.counter}`).on('click', function () {
                            EventBus.$emit('setCustomerId', customer.customer_id);
                            VueEventBus.$emit('openModalCustomer', true);
                            $(`#create_edit_customer_popup`).modal("show");
                        })
                    })


                    this.popupSelect.on('type', () => {
                        if (!($('#clear-input').length > 0) && $('#clear-input').parent().children().length <= 2) {
                            $(`.customer-tom-selector`).find(`.ts-control`).append(icon);
                        } else if ($(`#customers-modal-mobile-view_${vm.counter} #clear-input`).parent().children().length <= 2) {
                            $(`#customers-modal-mobile-view_${vm.counter} #clear-input`).show()
                        }
                    });



                }


                this.select.on('focus', () => {

                    $(".customerList_mobile.option.optionListValueCustomer").each(function (){
                        let customerId = $(this).attr("data-value");
                        $(this).find("#editCustomer").on('click', function () {
                            $(`#create_edit_customer_popup`).modal("show");
                            EventBus.$emit('setCustomerId', customerId);
                            VueEventBus.$emit('openModalCustomer', true);
                        })
                    });
                });

                this.popupSelect.on('blur', (value, item) => {
                    this.popupSelect.focus();
                })

                /**
                 * This to fix automatic scroll to top bug on dropdown autoloading tom-select
                 */
                this.popupSelect.on('load', () => {
                    let options = document.querySelectorAll('.customerList_mobile.option')
                    $('.customerList_mobile.option').removeClass('active')
                    $('.customerList_mobile.option').removeAttr('aria-selected')
                    this.select.clearActiveOption()
                    this.select.scrollToOption(options[options.length - 8], 'auto')


                    $(".customerList_mobile.option.optionListValueCustomer").each(function (){
                      let customerId = $(this).attr("data-value");
                      $(this).find(`#editCustomer${vm.counter}`).on('click', function () {
                        $(`#create_edit_customer_popup`).modal("show");
                        EventBus.$emit('setCustomerId', customerId);
                          VueEventBus.$emit('openModalCustomer', true);
                      })
                    })
                })
            })
        },
        // this function working with inquery convert to booking only (selected customer in tom select)
        selectedCustomerFun() {
            if(this.selectedCustomer && this.selectedCustomer.customer_id && this.selectedCustomer.customer_id !== 0 && typeof this.selectedCustomer.customer_id !=='undefined'){
                this.$nextTick(() => {
                    getCustomers({id: this.selectedCustomer.customer_id})
                        .then(response => {
                            this.select.addOption(response.data[0]);
                            this.select.addItem(this.selectedCustomer.customer_id);
                        })
                });
            }

        },
        listenToNewCustomerAdded(){
            let vm = this;
            EventBus.$on('newCustomerAdded',(customer_id) => {
                if(customer_id==vm.selectedCustomer.customer_id || !vm.selectedCustomer.customer_id){
              this.$nextTick(() => {
                getCustomers({id: customer_id})
                    .then(response => {
                      this.select.clear(true);
                      this.select.clearOptions();
                      this.select.addOption(response.data[0]);
                      this.select.addItem(customer_id);
                    })

                });
                }
            })
        },
      applyCustomClass() {
        this.isCustomClassApplied = true;
        this.showResetButton = true;
      },
      resetCustomClass() {

        this.isCustomClassApplied = false;
        this.showResetButton = false;
      }

    },
    mounted() {
        this.listenToNewCustomerAdded()
        this.listenToBrowserSize()
        this.initializeTomSelect();
        if (this.isMobile){
        this.initializePopupTomSelect();
        }
        this.listenToTomSelectEvents();
        if (this.isMobile) {
            this.listenToPopupTomSelectEvents();
        }
        this.selectedCustomerFun();
    },
    watch:{
      selectedCustomer(value) {
        this.$emit('input', value);
      },
      deep:true,
        immediate:true

    },


}


</script>

<style scoped>

.custom {
  padding: 0;
  align-items: flex-start !important;
  padding-top: 50px;
  position: fixed;
  background: white;
  height: 100%;
  z-index: 999999;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
}
.custom .icon-container{

  position: absolute;
  top: 5px;
  left: 5px;

  width: 28px;
  height: 26px;
}
.custom .counter
{
  position: absolute;
  top: 5px;
  left: 5px;

  width: 28px;
  height: 26px;
  font-size: 15px;
}
.custom .remove-button
{
  display: none;
}

.reset-style-btn{

  position: absolute;
  top: 5px;
  padding: 0px 5px;
  display: flex;
  width: 100px;
  justify-content: end;
  display: flex;
}
.custom .dropdown
{
  margin-left: 0px;
}
.custom-mobileStile{
  display: none;
}
.fixo
{

  display: none ;
}
@media screen and (max-width: 460px) {
  .d-hidden
  {
    opacity: 0;
  }
  .custom .fixo
  {
    display: flex;
    Z-INDEX: 999999;
    position: absolute;
    left: 4.7px;
    top: 89.7px;
  }
  .custom-mobileStile
  {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    opacity: 0;
    z-index: 9999;
  }
  .custom .custom-mobileStile
  {
    display: none;
  }
  .dropdown :deep(.vs__dropdown-menu) {
    overflow-y: unset; /* Allows scrolling within the dropdown */
    border: 0px;
    box-shadow: unset !important;
  }

}
.select-customer-container-icon {
    /*text-align: center;*/
    /*margin-top: 1% !important;*/
    /*width: 4% !important;*/
    position: relative !important;
    top: 13px !important;
    width: 45px !important;
    left: 4px;
}

.select-customer-container {
    /*width: 96% !important;*/
    width: 94.8% !important;
    position: absolute !important;
    left: 50px;
}

/*@media (max-width: 2550px) {*/
/*  .select-customer-container{*/
/*    width: 97% !important;*/
/*  }*/
/*}*/
@media (max-width: 1440px) {
    .select-customer-container {
        width: 95% !important;
    }
}

@media (max-width: 768px) {
    .select-customer-container-icon {
        top: 15px !important;
    }

    .select-customer-container {
        width: 92% !important;
    }

}

@media (max-width: 425px) {
    .select-customer-container-icon {
        width: 45px !important;
    }

    .select-customer-container {
        width: 86% !important;
    }
}

@media (max-width: 375px) {
    .select-customer-container {
        width: 84% !important;
    }
}


.dropdown.customer-dropdown {
    position: absolute;
    right: 31px;
    top: 15px;
    width: 30px;
    text-align: center;
}
</style>

<style scoped lang="scss">
@import "bootstrap/scss/bootstrap";
@import "tom-select/dist/css/tom-select.min.css";
@import "tom-select/dist/css/tom-select.bootstrap5.min.css";


@mixin modal-fullscreen() {
    padding: 0 !important; // override inline padding-right added from js

    .modal-dialog {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }

    .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
    }

}

@media (max-width: 767px) {
    .modal-fullscreen-xs-down {
        @include modal-fullscreen();
    }
}

@media (max-width: 991px) {
    .modal-fullscreen-sm-down {
        @include modal-fullscreen();
    }
}

@media (max-width: 1199px) {
    .modal-fullscreen-md-down {
        @include modal-fullscreen();
    }
}

.modal-fullscreen {
    @include modal-fullscreen();
}

#fltr_form .select-customer-container {
  left: 8px;
  width: 97% !important;
}
.w-90{width: 90% !important}
@media (min-width: 1000px) and (max-width:1600px){
  .w-90{
    width: 85% !important ;
  }
}
@media (min-width: 461px)and (max-width:999px) {
.w-90{
  width: 80% !important ;
}

}
@media screen and (max-width: 460px) {

  .custom-mobileStile
  {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    opacity: 0;
    z-index: 9999;
  }
  .custom .custom-mobileStile
  {
    display: none;
  }
  .w-90{
    width: 75% !important;
  }
}
#clear-input{
  display: none !important;
}
:deep(#clear-input){
  display: none !important;
}
.custom .w-90{
  width: 100%  !important;
  left: 10px;
}
.reset-style-btn{

  position: absolute;
  top: 5px;
  left: 10px;
  padding:0px 5px;
  justify-content: end;
  display: flex;
}
.custom .select-customer-container-icon
{
  position: absolute !important;
  top: 10px !important;
  right: 5px;
  padding:0px 5px;
}
.modal.fade.create-edit-customer-popup.in
{
    z-index: 999999999;
}
:deep(.modal.fade.create-edit-customer-popup.in)
{
    z-index: 999999999;
}
</style>

<style>
.dropdown_menu_custom_data{
    z-index: 999!important;
}
.no-scroll {
    overflow: hidden !important;
}
.modal-content{
    background-color: #FFFFFF !important;
}
.custom .ts-dropdown-content
 {
   max-height: 90% !important;
 }
.custom  :deep(.ts-dropdown-content)
 {
   max-height: 90% !important;
height: 100%;
}
.ts-control{
  z-index: unset !important;
}
</style>